import { BaseDatePicker } from "@/components/atom/datePicker/BaseDatePicker";
import { useLocalStorage } from "@/context/LocalStorageProvider";
import { useModal } from "@/context/ModalStackManager";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import "dayjs/locale/ko";
import { useState } from "react";

interface DateRangePickerProps {
  mode?: "single" | "range";
  dates: [Date | null, Date | null];
}

type RangeValue = [Date | null, Date | null];
type SingleValue = Date | null;

export const DateRangePicker = ({
  dates,
  mode = "range",
}: DateRangePickerProps) => {
  const { language } = useLocalStorage();
  const { closeModal } = useModal();

  const isSingle = mode === "single";

  // 내부 상태: 모드에 따라 타입 분리
  const [value, setValue] = useState<SingleValue | RangeValue>(
    isSingle ? dates[0] ?? null : [dates[0] ?? null, dates[1] ?? null]
  );

  // onChange: 모드별로 처리 및 모달 닫힘 조건 분기
  const handleChange = (next: SingleValue | RangeValue) => {
    setValue(next);

    if (isSingle) {
      // 단일 선택: 바로 닫고 [date, null] 형태로 반환(호환성 유지)
      const selected = next as SingleValue;
      closeModal([selected ?? null, null] as RangeValue);
    } else {
      // 범위 선택: 두 번째 날짜가 선택 완료되면 닫기
      const [start, end] = next as RangeValue;
      if (end !== null) {
        closeModal([start ?? null, end ?? null] as RangeValue);
      }
    }
  };

  return (
    <BaseDatePicker
      // Mantine 호환: 단일(default) vs 범위(range)
      type={isSingle ? "default" : "range"}
      value={value as any} // 래퍼 컴포넌트라 제네릭 캐스팅
      onChange={handleChange as any}
      // 옵션들
      allowSingleDateInRange // 같은 날짜로 범위 선택 가능(범위 모드에 유용)
      firstDayOfWeek={0}
      size="xl"
      previousIcon={<IconChevronLeft />}
      nextIcon={<IconChevronRight />}
      locale={language}
      monthLabelFormat="MM/YYYY"
    />
  );
};
